import { NavLink } from 'react-router-dom';
import { cn } from '../lib/utils';
import {
  LayoutDashboard,
  MonitorSmartphone,
  AlertTriangle,
  Users,
  Wrench,
  ShieldCheck,
  Hammer,
  BarChart3,
  Settings as SettingsIcon,
  Wind,
} from 'lucide-react';

const NAV = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, end: true, testId: 'nav-dashboard' },
  { to: '/devices', label: 'Device Monitor', icon: MonitorSmartphone, testId: 'nav-devices' },
  { to: '/alerts', label: 'Alerts', icon: AlertTriangle, testId: 'nav-alerts' },
  { to: '/customers', label: 'Customers', icon: Users, testId: 'nav-customers' },
  { to: '/tickets', label: 'Service Tickets', icon: Wrench, testId: 'nav-tickets' },
  { to: '/plans', label: 'Maintenance Plans', icon: ShieldCheck, testId: 'nav-plans' },
  { to: '/technicians', label: 'Technicians', icon: Hammer, testId: 'nav-technicians' },
  { to: '/analytics', label: 'Analytics', icon: BarChart3, testId: 'nav-analytics' },
  { to: '/settings', label: 'Settings', icon: SettingsIcon, testId: 'nav-settings' },
];

export default function Sidebar() {
  return (
    <aside
      className="hidden lg:flex flex-col w-64 shrink-0 border-r border-slate-200 bg-white"
      data-testid="sidebar"
    >
      <div className="h-16 flex items-center gap-2.5 px-5 border-b border-slate-200">
        <div className="h-8 w-8 rounded-md bg-[#0052CC] flex items-center justify-center text-white">
          <Wind className="h-4 w-4" strokeWidth={2.5} />
        </div>
        <div className="leading-tight">
          <div className="text-[15px] font-semibold text-slate-900 tracking-tight">JB Notify</div>
          <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-slate-500">HVAC Command Center</div>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-0.5">
        {NAV.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={item.testId}
              className={({ isActive }) =>
                cn(
                  'group flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-slate-100 text-slate-900'
                    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                )
              }
            >
              {({ isActive }) => (
                <>
                  <span className={cn('h-5 w-0.5 rounded-full transition-all', isActive ? 'bg-[#0052CC]' : 'bg-transparent')} />
                  <Icon className={cn('h-[18px] w-[18px] -ml-1', isActive ? 'text-[#0052CC]' : 'text-slate-500 group-hover:text-slate-700')} />
                  <span>{item.label}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </nav>
      <div className="p-3 border-t border-slate-200">
        <div className="rounded-lg bg-slate-50 border border-slate-200 p-3">
          <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 font-semibold">System Status</div>
          <div className="mt-2 flex items-center gap-2">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-60"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
            </span>
            <span className="text-xs text-slate-700 font-medium">All services operational</span>
          </div>
          <div className="mt-1 text-[10px] font-mono text-slate-500">Honeywell API · 99.98% uptime</div>
        </div>
      </div>
    </aside>
  );
}
